
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { SearchBar } from "./components/SearchBar";
import { RequestsTable } from "./components/RequestsTable";
import { useStudentRequests } from "./hooks/useStudentRequests";
import { useEffect } from "react";
import { useLanguagePath } from "@/utils/language";
import { useLanguage } from "@/components/LanguageContext";

export const StudentRequestsList = () => {
  const navigate = useNavigate();
  const { 
    filteredRequests, 
    isLoading, 
    searchTerm, 
    setSearchTerm, 
    refetch,
    deleteRequest
  } = useStudentRequests();
  const { getPath } = useLanguagePath();
  const { language } = useLanguage();

  // Forçar uma atualização dos dados ao montar o componente
  useEffect(() => {
    console.log("Component mounted, fetching data...");
    refetch();
  }, [refetch]);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950 dark:text-white">
          {language === 'pt' ? 'Pedidos de Alunos' : 'Student Requests'}
        </h2>
        <p className="text-muted-foreground dark:text-gray-300">
          {language === 'pt'
            ? 'Visualize os pedidos de alunos para se juntarem à sua plataforma'
            : 'View student requests to join your platform'}
        </p>
      </div>

      <div className="flex items-center justify-between">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium dark:text-white">
                {language === 'pt' ? 'Pedidos de Alunos' : 'Student Requests'}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <Button 
          onClick={() => navigate(getPath("/dashboard/students"))} 
          variant="outline" 
          className="border border-slate-gray-light/30 bg-transparent hover:bg-slate-gray-light/10 text-black dark:text-white"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          {language === 'pt' ? 'Voltar para Alunos' : 'Back to Students'}
        </Button>
      </div>

      <SearchBar 
        searchTerm={searchTerm} 
        onSearchChange={setSearchTerm} 
      />

      {isLoading ? (
        <div className="text-center py-8 bg-white/80 dark:bg-gray-800/80 rounded-xl shadow-sm border border-slate-100/50 dark:border-gray-700/50 backdrop-blur-sm">
          <div className="animate-pulse flex flex-col items-center">
            <div className="h-4 w-24 bg-slate-200 dark:bg-gray-700 rounded mb-3"></div>
            <div className="h-2 w-16 bg-slate-100 dark:bg-gray-600 rounded"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white/80 dark:bg-gray-800/80 rounded-xl shadow-sm border border-slate-100/50 dark:border-gray-700/50 backdrop-blur-sm overflow-hidden">
          <RequestsTable 
            filteredRequests={filteredRequests}
            onDeleteRequest={deleteRequest}
          />
        </div>
      )}
    </div>
  );
};
